
export const commonTranslations = {
  // Hero Section tagline
  heroTagline: {
    fr: "Collective • Trailblazers • Sessions • Pure joy",
    en: "Collective • Trailblazers • Sessions • Pure joy"
  },
  // Navbar
  visionMission: {
    fr: "Vision & Mission",
    en: "Vision & Mission"
  },
  services: {
    fr: "Services",
    en: "Services"
  },
  members: {
    fr: "Annuaire",
    en: "Directory"
  },
  join: {
    fr: "Rejoindre",
    en: "Join"
  },
  joinSingularite: {
    fr: "Rejoindre Singularité.club",
    en: "Join Singularité.club"
  },

  // Navigation Menu
  vision: {
    fr: "Vision",
    en: "Vision"
  },
  benefits: {
    fr: "Bénéfices",
    en: "Benefits"
  },
  targetAudience: {
    fr: "À qui",
    en: "For whom"
  },
  testimonials: {
    fr: "Témoignages",
    en: "Testimonials"
  },
};
